module.exports = __webpack_public_path__ + "static/img/jianzhu02.096a29e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu02.png
// module id = UP1f
// module chunks = 12